import React from "react";
import { TrendingUp, Shield, Users, Award } from "lucide-react";

const SharedLayout = () => {
  return (
    <div className="w-full h-full bg-gradient-to-br from-[#0B1120] via-[#102147] to-[#0B1120] relative overflow-hidden flex flex-col justify-between p-10 lg:p-12 text-white">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Gradient Orbs - More Subtle */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl"></div>

      {/* Content Container */}
      <div className="relative z-10 flex flex-col h-full justify-between max-w-xl">
        {/* Logo Section */}
        <div className="flex items-center gap-3">
          
          <span className="text-2xl font-bold tracking-tight">
           
          </span>
        </div>

        {/* Main Content - Centered */}
        <div className="space-y-8">
          <div className="space-y-4 text-center">
            <h1 className="text-4xl lg:text-5xl font-bold leading-tight">
              Invest in India's
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#44D2F6] to-[#0C7FA5]">
                Unlisted Shares
              </span>
            </h1>
            <p className="text-lg text-gray-300 leading-relaxed max-w-md mx-auto">
              Access exclusive pre-IPO opportunities and build wealth with India's most trusted investment platform.
            </p>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-3 gap-4 pt-6">
            <div className="text-center">
              <div className="flex items-center justify-center mb-2">
                <div className="p-2.5 bg-blue-500/10 rounded-xl border border-blue-500/20">
                  <Shield className="w-5 h-5 text-[#44D2F6]" />
                </div>
              </div>
              <div className="text-2xl font-bold text-white">100%</div>
              <div className="text-xs text-gray-400 mt-1">Secure</div>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center mb-2">
                <div className="p-2.5 bg-purple-500/10 rounded-xl border border-purple-500/20">
                  <Users className="w-5 h-5 text-purple-400" />
                </div>
              </div>
              <div className="text-2xl font-bold text-white">50k+</div>
              <div className="text-xs text-gray-400 mt-1">Investors</div>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center mb-2">
                <div className="p-2.5 bg-green-500/10 rounded-xl border border-green-500/20">
                  <Award className="w-5 h-5 text-green-400" />
                </div>
              </div>
              <div className="text-2xl font-bold text-white">₹500Cr+</div>
              <div className="text-xs text-gray-400 mt-1">Invested</div>
            </div>
          </div>
        </div>

        {/* Testimonial - Bottom */}
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-5">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#44D2F6] to-[#0C7FA5] flex items-center justify-center flex-shrink-0 text-sm font-semibold">
              RK
            </div>
            <div className="flex-1">
              <p className="text-sm text-gray-300 leading-relaxed mb-2">
                "InvestHive made it incredibly easy to invest in unlisted shares. Professional platform with excellent support."
              </p>
              <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-white">Rajesh Kumar</span>
                <span className="text-xs text-gray-500">•</span>
                <span className="text-xs text-gray-400">Verified Investor</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SharedLayout;
